import { Component, inject, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { AuthService } from '../../../core/auth/auth.service';
import { SearchService } from '../../../features/search/search.service';
import { WelcomeBarComponent } from '../../../features/welcome-bar/welcome-bar.component';
import { QuoteOfTheDayComponent } from '../../../features/quote-of-the-day/quote-of-the-day.component';
import { SpikeSearchBoxComponent } from '../search-box/spike-search-box.component';
import { SearchResultsComponent } from '../../../features/search/search-results/search-results.component';

@Component({
  selector: 'spike-landing',
  standalone: true,
  imports: [
    AsyncPipe,
    WelcomeBarComponent,
    QuoteOfTheDayComponent,
    SpikeSearchBoxComponent,
    SearchResultsComponent,
  ],
  template: `
    <div class="w-full px-8 py-10">
      @if ((searched$ | async) !== true) {
        <!-- Editorial split: hero left, quote right -->
        <div class="grid gap-12 lg:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)]">
          <section class="flex flex-col gap-10 pt-6">
            <cmt-welcome-bar />
            <spike-search-box />
          </section>
          <aside class="lg:pt-12">
            <cmt-quote-of-the-day />
          </aside>
        </div>
      } @else {
        <!-- Results: compact search + AG-Grid -->
        <div class="flex h-[calc(100vh-9rem)] flex-col gap-4">
          <spike-search-box [compact]="true" />
          <div class="min-h-0 flex-1 overflow-hidden rounded-2xl border border-border bg-card shadow-sm">
            <cmt-search-results class="block h-full" />
          </div>
        </div>
      }
    </div>
  `,
})
export class SpikeLandingComponent implements OnInit {
  private authService = inject(AuthService);
  private searchService = inject(SearchService);

  searched$ = this.searchService.hasSearched$;

  ngOnInit(): void {
    if (this.authService.isLoggedIn) {
      this.authService.fetchUserDetails().subscribe();
    }
  }
}
